export const URLS = {
  downloadShipmentDocument: (jobNumber, docId) =>
    `/api/job/${jobNumber}/document/${docId}`,
  uploadShipmentDocument: jobNumber => `/api/job/${jobNumber}/document`,
};
